<template>
<!--  <br v-if="$q.screen.lt.md" />-->
  <br class="lt-md" />
</template>

<script>
export default {
}
</script>
